import { createSelector } from '@ngrx/store';
import { BrandSearchResponse } from '~app/modules/brand-plp/models';
import { getBrandPLPState } from '../feature.selector';
import { BrandPLPPageState } from '../state';
import { SearchResponse } from '~app/modules/catalog/models';

export const getProductsPayload = createSelector(
  getBrandPLPState,
  (state: BrandPLPPageState) => state && state.products.payload
);

export const getProducts = createSelector(getProductsPayload, (payload) => {
  return payload && payload.products && payload.products.items;
});

export const getLastRequestFilterParameters = createSelector(
  getBrandPLPState,
  (state: BrandPLPPageState) => state.products.currentFilter
);

export const getProductsTotalCountForBrand = createSelector(
  getProductsPayload,
  (payload: BrandSearchResponse) => payload && payload.products && payload.products.totalCount
);

export const isProductsLoading = createSelector(
  getBrandPLPState,
  (state: BrandPLPPageState) => state?.products?.loading
);

export const shouldShowNoFoodResult = createSelector(getProductsPayload, (payload: SearchResponse) => {
  return payload && payload.metaData && payload.metaData.hasFood;
});
